/* eslint-disable no-global-assign */
/* global ValidatorUpdateDisplay autosize Cookies bootstrap: false */

let resizingTimer = null
window.fieldIsValid = []
window.fieldValidityTimer = []

let initControlsAndModals = function () {
  // add necessary css classes to checkboxlist
  $(
    'div.form-check > input[type=checkbox]:not(.form-check-input),div.form-check > input[type=radio]:not(.form-check-input)'
  ).addClass('form-check-input')
  $('div.form-check > label:not(.form-check-label)').addClass('form-check-label')

  // add table sorting class
  $('table.table[data-sort-field]').each(function () {
    let $table = $(this)
    $table.find('tr th a').each(function () {
      let $a = $(this)
      $a.removeClass('sort-a').removeClass('sort-d')
      if ($a.attr('href').indexOf('Sort$' + $table.attr('data-sort-field') + "'") >= 0) {
        $a.addClass($table.attr('data-sort-dir').substring(0, 6))
      }
    })
    $table.removeAttr('data-sort-field')
    $table.removeAttr('data-sort-dir')
  })

  if (typeof autosize !== 'undefined') {
    $('textarea.form-control:not(.autosizing):visible').each(initAutosize)
  }

  $('textarea:not(.cc-init)').on('keyup paste focus', characterCounterUpdate).addClass('cc-init')
  $('textarea:not(.cc-init)').on('blur', characterCounterRemove).addClass('cc-init')
}

/** AUTOSIZE **/
let initAutosize = function () {
  let $this = $(this)
  autosize($this)
  $this.addClass('autosizing')
}

// POPOVERS
let popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'))
popoverTriggerList.map(function (popoverTriggerEl) {
  return new bootstrap.Popover(popoverTriggerEl)
})

// FORM VALIDATION
let setFieldValidity = function (controlId) {
  if (window.fieldIsValid[controlId]) {
    $('#' + controlId)
      .closest('input.form-control,textarea.form-control,select.form-control,select.form-select')
      .removeClass('is-invalid')
  } else {
    $('#' + controlId)
      .closest('input.form-control,textarea.form-control,select.form-control,select.form-select')
      .addClass('is-invalid')
  }
  window.fieldIsValid[controlId] = null
}

// Updating .net form validator
if (typeof ValidatorUpdateDisplay !== 'undefined') {
  let originalValidatorUpdateDisplay = ValidatorUpdateDisplay

  ValidatorUpdateDisplay = function (val) {
    // this is necessary since several validators can fire against one field.  This is setup so that if one fails then the other won't overwrite it.
    window.fieldIsValid[val.controltovalidate] = window.fieldIsValid[val.controltovalidate] !== false && val.isvalid
    clearTimeout(window.fieldValidityTimer[val.controltovalidate])
    window.fieldValidityTimer[val.controltovalidate] = setTimeout(setFieldValidity, 60, val.controltovalidate)
    originalValidatorUpdateDisplay(val)
  }
}

// window resize
let windowResize = function () {
  // $('.grid-view').each(function () {
  //   if ($(this).height() < 300 && $(this).find('>div').height() > 300) {
  //     $(this).css('min-height', 300)
  //   }
  // })

  resizingTimer = null
}

let windowResizeDebounce = function () {
  // $('section.main-section').removeAttr('style')
  // $('.grid-view').removeAttr('style')

  if (resizingTimer !== null) {
    clearTimeout(resizingTimer)
  }
  resizingTimer = setTimeout(windowResize, 50)
}

let characterCounterUpdate = function (e) {
  let $this = $(this)
  let $cc
  // only characterCount if there is a maxlength set
  if (typeof $this.attr('maxlength') !== 'undefined') {
    // if the character counter doesn't exist, create it
    if (!$this.next().hasClass('char-counter')) {
      $('<span class="char-counter badge text-info cc-hidden"></span>').insertAfter($this)
      let t = window.setTimeout(function () {
        $('.cc-hidden').removeClass('cc-hidden')
      }, 150)
    }
    $cc = $this.next()
    $cc.text($this.val().length + '/' + $this.attr('maxlength'))
    if ($this.val().length >= $this.attr('maxlength')) {
      $this.addClass('at-maxlength')
      $cc.removeClass('text-info').removeClass('text-warning').addClass('text-bg-danger fw-bold')
    } else if ($this.attr('maxlength') > 0 && $this.val().length / $this.attr('maxlength') > 0.9) {
      $this.removeClass('at-maxlength')
      $cc.removeClass('text-info').removeClass('text-bg-danger fw-bold').addClass('text-warning')
    } else {
      $this.removeClass('at-maxlength')
      $cc.removeClass('text-warning').removeClass('text-bg-danger fw-bold').addClass('text-info')
    }
  }
}

let characterCounterRemove = function (e) {
  let $this = $(this)
  if ($this.next().hasClass('char-counter')) {
    $this.next().addClass('cc-hidden')
    let t = window.setTimeout(function () {
      $this.next().remove()
    }, 100)
  }
}

// eslint-disable-next-line no-unused-vars
let restoreAcc = function () {
  // this is called via SunstrataIms.Master.vb
  $('body').addClass('no-transitions')
  $('.accordion-collapse').each(function () {
    if (Cookies.get('acc-' + $(this).attr('id')) == '1') {
      $(this).collapse('show')
      // console.log('showing ' + $(this).attr('id'))
    }
  })
  window.setTimeout(function () {
    $('body').removeClass('no-transitions')
  }, 1000)
}

// MAIN
$(function () {
  setInterval(initControlsAndModals, 100)

  $('.accordion-collapse').on('hidden.bs.collapse', function () {
    Cookies.remove('acc-' + $(this).attr('id'))
  })
  $('.accordion-collapse').on('shown.bs.collapse', function () {
    Cookies.set('acc-' + $(this).attr('id'), '1')
  })

  // remove accordion state cookies on page load
  $('.accordion-collapse').each(function () {
    Cookies.remove('acc-' + $(this).attr('id'))
  })

  $(window).on('scroll', function () {
    if (this.scrollY > 20) {
      $('.returntotop').addClass('show')
    } else {
      $('.returntotop').removeClass('show')
    }
  })

  $('.collapse').on('shown.bs.collapse', windowResize)
  $('.collapse').on('hidden.bs.collapse', windowResize)
  window.onresize = windowResizeDebounce
  windowResizeDebounce()
})
